module.exports = __webpack_public_path__ + "static/img/h-1.4fde91d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-1.jpg
// module id = VCha
// module chunks = 1